import content from '../generated/content.json';

export const education = content.education.education;

export function getEducationById(id) {
  return education.find((item) => item.id === id);
}
